/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/

import ccTab from '@/components/common/tab/index.vue';
import contentTable from '@/components/common/more-tab-content/content-table/index.vue';
import linkMixins from '../mixin/link.js';

export default {
    name: 'page-list',
    components: {ccTab, contentTable},
    mixins:[linkMixins],
    data() {
        return {
            tabList: [
                {
                    name: '送达',
                    code: 'sdgg'
                },
                {
                    name: '开庭',
                    code: 'ktgg'
                },
                {
                    name: '宣告',
                    code: 'xg'
                },
                {
                    name: '催告',
                    code: 'cg'
                },
                {
                    name: '拍/变卖',
                    code: 'pbmgg'
                },
                {
                    name: '其他',
                    code: 'qtgg'
                }
            ],
            active: 'sdgg',
            zgy: {
                name: '最高人民法院',
                code: '0'
            },
            gjrmfyList: [
                {
                    name: '辽宁',
                    code: '600'
                },
                {
                    name: '天津',
                    code: '51'
                },
                {
                    name: '山东',
                    code: '1850'
                },
                {
                    name: '江苏',
                    code: '1150'
                },
                {
                    name: '上海',
                    code: '1100'
                },
                {
                    name: '湖北',
                    code: '2250'
                },
                {
                    name: '浙江',
                    code: '1300'
                },
                {
                    name: '福建',
                    code: '1600'
                },
                {
                    name: '广东',
                    code: '2550'
                },

                {
                    name: '广西',
                    code: '2750'
                },
                {
                    name: '海南',
                    code: '2900'
                }
            ],
            hsfyList: [
                {
                    name: '大连',
                    code: '732'
                },
                {
                    name: '天津',
                    code: '72'
                },
                {
                    name: '青岛',
                    code: '2010'
                },
                {
                    name: '南京',
                    code: '1151'
                },
                {
                    name: '上海',
                    code: '1129'
                },
                {
                    name: '武汉',
                    code: '2367'
                },
                {
                    name: '宁波',
                    code: '1402'
                },
                {
                    name: '厦门',
                    code: '1693'
                },
                {
                    name: '广州',
                    code: '2701'
                },
                {
                    name: '北海',
                    code: '2878'
                },
                {
                    name: '海口',
                    code: '2925'
                }
            ],
            activeFy:'0'
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'诉讼服务',
                key:'ssfw',
                path:'/ssfw'
            }];
            const listItem = this.tabList.filter(item => item.code === this.active)[0];
            console.log(listItem);
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.active = this.$route.query.tab || 'sd';
        },
        // 页签切换
        handelTabChange(code) {
            this.active = code;
        },
        changeFy(code) {
            this.activeFy = code;
        }
    }
};
